import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M48 24c0 13.26-10.74 24-23.99 24S0 37.26 0 24 10.75 0 24.01 0 48 10.75 48 24ZM22.14 11.57c-3.76 0-6.2.21-7.97.86-2.97 1.16-5.02 3.58-5.02 6.76 0 2.65 1.23 4.57 4.81 6.78 3.81 2.31 4.57 3.08 4.57 4.47 0 1.52-1.49 3.26-5.34 3.26-1.34 0-3.36-.19-4.65-.5l-.62-.15c-.34.92-1.12 3.1-1.36 3.89l.61.18c1.16.37 3.92.66 5.89.66 6.57 0 10.49-3.97 10.49-8.12 0-2.55-1.16-4.49-5.08-6.94-1.97-1.21-2.97-1.99-3.57-2.6-.49-.63-.55-1.1-.55-1.6s.11-1.02.42-1.42c.34-.5.96-.81 1.8-1.07.86-.29 2.47-.29 4.96-.29h2.33l1.66-4.15h-3.39Zm5.88 0H39.7c.55 0 .65.39.44.81-.76 1.89-7.97 19.95-7.97 19.95h-4.82s5.69-14.5 6.64-16.66c-.22 0-.42 0-.69.01-.53.02-1.34.04-3.07.04h-3.87l1.66-4.15Z",
      style: {"fill":"#c4d600","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "S7-logo"}) } }